// extracted by mini-css-extract-plugin
export default {"versionBadge":"campaign-small_versionBadge__D0hNn"};